module.exports = __webpack_public_path__ + "img/error.b641c146.png";